if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    constructor() {
      super();
      this.handlerRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      const updates = {};
      updates[this.getAttribute('data-key')] = 0;

      updateQuantity({ updates });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handlerRef);

    }

    connectedCallback() {
      this.addEventListener('click', this.handlerRef);
    }
  }

  customElements.define('cart-remove', CartRemove);
}
